import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ClearableInput from '../clearableInput/ClearableInput';
var TreeSearch = /*#__PURE__*/React.memo(function (props) {
  var value = props.value,
    className = props.className,
    placeholder = props.placeholder,
    onChange = props.onChange;
  var classes = classNames('TreeSearch', className);
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement("div", {
    className: 'input-group flex-1-0'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'input-group-addon'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'rioglyph rioglyph-search',
    "aria-hidden": 'true'
  })), /*#__PURE__*/React.createElement(ClearableInput, {
    value: value,
    onChange: onChange,
    placeholder: placeholder
  })));
});
TreeSearch.displayName = 'TreeSearch';
TreeSearch.defaultProps = {
  onChange: function onChange() {}
};
TreeSearch.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string
};
export default TreeSearch;